import { EOrganization, ESnapshot } from 'lib/types';
import { useSyncExportSettings } from 'lib/frontend/hooks/useSyncExportSettings';

export const useSyncFormat = (
  newspaper: ESnapshot<EOrganization> | undefined
) => {
  const settings = useSyncExportSettings(newspaper);
  return settings?.format;
};
